import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrivacyPolicyComponent } from './Pages/privacy-policy/privacy-policy.component';
import { DeleteAccountComponent } from './Pages/delete-account/delete-account.component';

const routes: Routes = [
  { path:'privacy-policy',component:PrivacyPolicyComponent },
  { path:'about-us',component:PrivacyPolicyComponent },
  { path:'term-condition',component:PrivacyPolicyComponent },
  { path:'delete-account',component:DeleteAccountComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
